<template>
  <div>
    <div class="home-topbar">
      <div class="container clearfix">
        <div class="topbar_nav">
          <ul>
            <li v-if="$store.state.userInfo.role === 2">欢迎光临京麦通供应商平台&#8195;</li>
            <li v-else>欢迎光临京麦通分销平台&#8195;</li>
            <li v-if="isNaName">
              <a href="javascript:void(0);" @click="$router.push('/login')">登录</a>
              <span class="line">|</span>
            </li>
            <li v-if="isNaName">
              <a href="javascript:void(0);" @click="$router.push('/register')">注册</a>
              <span class="line">|</span>
            </li>
            <li v-if="!isNaName && $store.state.userInfo.role === 1">
              <span class="username" style="color:#0365b9;">{{ $store.state.userInfo.userName }} [ID:{{ $store.state.userInfo.userNumber }} ]</span>
              <a href="javascript:;" @click="loginout()">&nbsp;退出登录</a>
            </li>
            <li v-if="!isNaName && $store.state.userInfo.role === 2">
              <span class="username" style="color:#0365b9;">{{ $store.state.userInfo.warehouseName }} [{{$store.state.userInfo.loginAccount}}]</span>
              <a href="javascript:;" @click="loginout()">&nbsp;退出登录</a>
            </li>
          </ul>
        </div>
        <div class="shopcart" ref="cart" v-if="$store.state.userInfo.role !== 2">
          <div @click="goShopCart" class="cart">
            <span class="iconfont icon-gouwuche1"></span>
            <em>购物车</em>
            <span class="buy_num" v-if="!isNaName">({{ shopCart.length }})</span>
            <span class="buy_num" v-else>(0)</span>
          </div>
        </div>
        <div class="shopcart" ref="cart" v-if="$store.state.userInfo.role === 2">
          <div @click="goWHShopCart" class="cart">
            <span class="iconfont icon-gouwuche1"></span>
            <em>购物车</em>
            <span class="buy_num" v-if="!isNaName">({{ shopWHCart.length }})</span>
            <span class="buy_num" v-else>(0)</span>
          </div>
        </div>
        <div class="login_control" v-if="$store.state.userInfo.role !== 2">
          <ul>
            <li>
              <a
                class="el-icon-user-solid"
                href="javascript:void(0);"
                @click="goUserInfo"
                >个人中心</a
              >
              <span class="line">|</span>
            </li>
            <li>
              <a
                class="el-icon-s-order"
                href="javascript:void(0);"
                @click="goOrder"
                >我的订单</a
              >
              <span class="line">|</span>
            </li>
            <li>
              <a class="el-icon-question" href="javascript:void(0);"
                >帮助中心</a
              >
              <span class="line">|</span>
            </li>
            <li>
              <a
                class="el-icon-data-analysis"
                href="javascript:void(0);"
                @click="$router.push('/loginProvider')"
                >供应商入口</a
              >
            </li>
          </ul>
        </div>
        <div class="login_control" v-if="$store.state.userInfo.role === 2">
          <ul>
            <li>
              <a class="el-icon-user-solid" href="javascript:void(0);" @click="openOnlineWindow">在线用户
                <span class="buy_num">({{ onlineUsers.length }})</span>
              </a>
              <online-list ref="onlineList"></online-list>
              <span class="line">|</span>
            </li>
            <li>
              <a class="el-icon-user-solid" href="javascript:void(0);" @click="goWHUserInfo" >个人中心</a>
              <span class="line">|</span>
            </li>
            <li>
              <a class="el-icon-s-order" href="javascript:void(0);" @click="goWHOrder">我的订单</a>
              <span class="line">|</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "element-ui/lib/theme-chalk/base.css";
import { mapGetters } from "vuex";
import { WebsocketMixin } from '@/mixins/WebsocketMixin'
import { loginPollingMixin } from '@/mixins/loginPollingMixin';
import onlineList from '@/components/main/onlineList';
export default {
  mixins: [
    WebsocketMixin,
    loginPollingMixin
  ],
  components: {
    onlineList
  },
  data() {
    return {
      show: false,
      showHiden: false,
      socketUrl: '/websocket/',
      logoutFun: this.loginout,
    };
  },
  created() {
  },
  mounted () {
  },
  methods: {
    goWHUserInfo(){
      // this.$store.commit("hasLogin");
      this.getHasLogin(1);
      if (!this.isNaName) {
        this.$router.push("/provider/accountInfo");
      } else {
        this.tologin1();
      }
    },
    goWHShopCart(){
      // this.$store.commit("hasLogin");
      this.getHasLogin(1);
      if (!this.isNaName) {
        this.$router.push("/shopWHCart");
      } else {
        this.tologin1();
      }
    },
    goWHOrder() {
      // this.$store.commit("hasLogin");
      this.getHasLogin(1);
      if (!this.isNaName) {
        this.$router.push("/provider/whOrderMain/2");
      } else {
        this.tologin1();
      }
    },
    goOrder() {
      // this.$store.commit("hasLogin");
      this.getHasLogin(0);
      if (!this.isNaName) {
        this.$router.push("/user/orderMain/1");
      } else {
        this.tologin();
      }
    },
    goUserInfo() {
      // this.$store.commit("hasLogin");
      this.getHasLogin(0);
      if (!this.isNaName) {
        this.$router.push("/user/personal");
      } else {
        this.tologin();
      }
    },
    goShopCart() {
      // this.$store.commit("hasLogin");
      this.getHasLogin(0);
      if (!this.isNaName) {
        this.$router.push("/shopCart");
      } else {
        this.tologin();
      }
    },
    tologin() {
      this.$message({
        message: "请先登录！",
        type: "warning",
      });
      this.$router.push("/login");
    },
    tologin1() {
      this.$message({
        message: "请登录供应商身份账号！",
        type: "warning",
      });
      this.$router.push("/loginProvider");
    },
    showCart() {
      this.show = true;
      this.$refs.cart.style.color = "#5cadff";
      this.$refs.cart.style.backgroundColor = "#fff";
    },
    hideCart() {
      this.show = false;
      this.$refs.cart.style.color = "#b0b0b0";
      this.$refs.cart.style.backgroundColor = "#424242";
    },
    openOnlineWindow(){
      this.$refs.onlineList.isOpen = !this.$refs.onlineList.isOpen;
    },
    // 退出登录
    loginout() {
      this.$store.state.userInfo = {};
      // 清除本地存储
      window.sessionStorage.clear();
      const savedAccounts = localStorage.getItem('savedLoginAccounts');
      const savedAccountsWH = localStorage.getItem('savedLoginAccountsWH');
      window.localStorage.clear();
      window.localStorage.setItem("savedLoginAccounts", savedAccounts);
      window.localStorage.setItem("savedLoginAccountsWH", savedAccountsWH);
      this.$store.state.socket.warehouseLogout = 0
      //关闭socket连接
      this.websocketClose()

      // 如果是home，不跳转
      if (this.$route.fullPath != "/home") {
        this.$router.replace("/home");
      }
    },
    getHasLogin(){
      if(this.$store){
        this.$store.commit("hasLogin");
        return true;
      }
      return false;
    }
  },
  watch: {
    warehouseLogout: {
      handler(newValue) {
        
        // console.log("topbar.vue.watch.warehouseLogout:供应商退出登录", newValue)
        if(!newValue || newValue == 0){
          return
        }
        const that = this
        if(that.$store.state.userInfo.role === 2){
          //
          // that.$alert('该供应商（'+ that.$store.state.userInfo.userName +'）在其他电脑登录请退出', '重复登录', {
          //   confirmButtonText: '确定',
          //   callback: action => {
          //   }
          // });
          that.$message({
            showClose: true,
            type: 'warning',
            duration: 30000,
            message: '该供应商（'+ that.$store.state.userInfo.userName +'）在其他浏览器登录，将退出'
          });
          // that.loginout()
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    total_price: function() {
      return this.cartItem.reduce((total, current) => {
        return total + current.product.product_price * current.product.buy_num;
      }, 0);
    },
    shopCart: function() {
      return this.$store.state.shopCart;
    },
    shopWHCart: function() {
      return this.$store.state.shopWHCart;
    },
    onlineUsers: function() {
      return this.$store.state.onlineUsers;
    },
    warehouseLogout: function() {
      return this.$store.state.socket.warehouseLogout;
    },
    // ...mapState("shopCart", {
    //   cartItem: (state) => state.cartItem,
    // }),
    ...mapGetters(["isNaName"]),
  },
};
</script>

<style lang="scss" scoped>
$mainColor: #5cadff;
.container {
  font-size: small;
  margin: 0 auto;
  position: relative;
}
.home-topbar {
  background: #f2f2f2;
  color: #333333;
  height: 40px;
  .topbar_nav {
    float: left;
    ul {
      li {
        line-height: 40px;
        float: left;
        margin-left: 5px;
        a {
          color: #333333;
          &:hover {
            color: #5cadff;
          }
        }
        span.line {
          margin: 0 5px;
          color: #333333;
        }
        &:last-child {
          span.line {
            display: none;
          }
        }
      }
    }
  }
  .login_control {
    float: right;
    ul {
      li {
        line-height: 40px;
        float: left;
        a {
          color: #333333;
          &:hover {
            color: #5cadff;
          }
        }
        span.line {
          margin: 0 5px;
          color: #393e3e;
        }
        &:last-child {
          span.line {
            display: none;
          }
        }
        a.userInfo {
          width: 100px;
          position: relative;
          display: inline-block;
          height: 40px;
          line-height: 40px;
          text-align: center;
          &:hover {
            background-color: #fff;
            span.username {
              color: #5cadff;
            }
            span.iconfont {
              color: $mainColor;
            }
          }
          span.username {
            color: #5cadff;
            font-size: 12px;
          }
          span.iconfont {
            margin-left: 5px;
            margin-right: 5px;
            color: #757575;
            font-size: 12px;
          }
          .hiden {
            height: 150px;
            width: 100%;
            padding: 7px 0;
            background-color: #fff;
            text-align: center;
            position: absolute;
            top: 40px;
            left: 0px;
            z-index: 10;
            box-shadow: 0 10px 10px rgba(0, 0, 0, 0.15);
            ul {
              li {
                width: 100%;
                height: 30px;
                line-height: 30px;
                a {
                  width: 100%;
                  color: #333;
                }
                &:hover {
                  a {
                    color: $mainColor;
                  }
                  background-color: #f5f5f5;
                }
              }
            }
          }
        }
      }
    }
  }
  .shopcart {
    margin-left: 15px;
    float: right;
    line-height: 40px;
    text-align: center;
    width: 120px;
    height: 40px;
    background-color: #424242;
    color: #b0b0b0;
    .cart {
      cursor: pointer;
      em {
        margin-left: 4px;
      }
      .buy_num {
        margin-left: 7px;
      }
    }
    .hide {
      position: absolute;
      z-index: 200;
      top: 40px;
      right: 0px;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
      background-color: #fff;
      .miniCart {
        .transition-box {
          width: 316px;
          height: 100px;
          text-align: center;
          color: #333;
          line-height: 100px;
          box-sizing: border-box;
        }
        .miniCartList {
          width: 316px;
          padding: 0 20px;
          margin-top: 20px;
          ul {
            li {
              padding: 10px 0;
              height: 60px;
              a {
                line-height: 60px;
                .imgLeft {
                  float: left;
                  margin-right: 10px;
                  img {
                    width: 60px;
                    height: 60px;
                  }
                }
                .itemName {
                  width: 85px;
                  float: left;
                  margin: 10px 0;
                  line-height: 16px;
                  color: #424242;
                }
                .itemPrice {
                  float: right;
                  color: #424242;
                }
              }
            }
          }
        }
        .miniCart-total {
          padding: 15px 20px;
          span.total {
            float: left;
            color: #333;
            line-height: 20px;
            span.price {
              color: $mainColor;
              display: block;
              font-size: 14px;
              em {
                font-size: 25px;
              }
            }
          }
          .btn {
            float: right;
            width: 132px;
            height: 40px;
            color: white;
            text-align: center;
            line-height: 40px;
            background-color: $mainColor;
          }
        }
      }
    }
  }
}
</style>
